module.exports = __webpack_public_path__ + "img/1994_S.c4e770bf.png";